import { gql } from "@apollo/client";

export const SearchLocation = gql`
  query NE_SearchLocation($locationText: String!) {
    result: search_location(text: $locationText, limit: 20) {
      locations {
        id
        village
        district
        subdistrict
        province
      }
    }
}
`
